import { render, staticRenderFns } from "./Visits.vue?vue&type=template&id=412fa9fc&"
import script from "./Visits.vue?vue&type=script&lang=js&"
export * from "./Visits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports